function service(state = {
  result: '', saveServiceInvoiceResult: '', serviceReset: false, serviceInfo: null, serviceInvoice: '',
  serviceUsedParts: '', serviceAttachments: [], serviceCountReport: [], serviceDeadlineReport: [], staffTotalfunctions: '',
  staffReportList: [], usedPartsList: [], serialHistoryPopup: '', serialHistory: [], selectStaffPopup: '', agentList: [], repairBugList: [],
  faultsByCustomer: [], customerFaultsPopStatus: '', serviceStatusList: [], signaturePopStaus: '', serviceReceipt: '', serviceTotalCost: '',
  borrowListPop: '', usedPartsBorrowList: [], serviceMessageList: [], serviceStaffPayments: [], searchServiceFilters: {}, custReqWithoutLoginList: {},
  custReqWithoutLoginFilters: {}, serviceRejectHistory: {}, manageSendingStaffList: {}, manageSendingStaffFilters: {}, saAccBookFilters: {}
}, action) {

  switch (action.type) {

    case "ADD_SERVICE":
      return {
        ...state,
        result: action.data
      };
    case "RESET_SERVICE":
      return {
        ...state,
        serviceReset: action.data
      }
    case "GET_SERVICE":
      return {
        ...state,
        serviceInfo: action.data
      }
    case "GET_SERVICE_INVOICE":
      return {
        ...state,
        serviceInvoice: action.data
      }
    case "GET_SERVICE_USEDPARTS":
      return {
        ...state,
        serviceUsedParts: action.data
      }
    case "GET_SERVICE_ATTACHMENTS":
      return {
        ...state,
        serviceAttachments: action.data
      }
    case "GET_RELATEDSTAFFS":
      return {
        ...state,
        relatedStaffs: action.data
      }
    case "GET_AGENT_LIST":
      return {
        ...state,
        agentList: action.data
      }
    case "GET_SERVICE_COUNT":
      return {
        ...state,
        serviceCountReport: action.data
      }
    case "SERVICE_DEADLINE_REPORT":
      return {
        ...state,
        serviceDeadlineReport: action.data
      }
    case "STAFF_TOTAL_FUNCTION":
      return {
        ...state,
        staffTotalfunctions: action.data
      }
    case "GET_STAFF_REPORT":
      return {
        ...state,
        staffReportList: action.data
      }
    case "SEARCH_USED_PARTS":
      return {
        ...state,
        usedPartsList: action.data
      }
    case "SAVE_SERVICE_INVOICE":
      return {
        ...state,
        saveServiceInvoiceResult: action.data
      }
    case "SET_SERIALHISTORY_POPUP":
      return {
        ...state,
        serialHistoryPopup: action.data
      }
    case "GET_SERIAL_HISTORY":
      return {
        ...state,
        serialHistory: action.data

      }
    case "SET_SELECTSTAFF_POPUP":
      return {
        ...state,
        selectStaffPopup: action.data
      }
    case "GET_REPAIR_BUGS":
      return {
        ...state,
        repairBugList: action.data
      }
    case "LOAD_FAULTS_CUSTOMER":
      return {
        ...state,
        faultsByCustomer: action.data
      }
    case "SET_CUSTOMER_FAULTS":
      return {
        ...state,
        customerFaultsPopStatus: action.data
      }
    case "GET_SERVICE_STATUS":
      return {
        ...state,
        serviceStatusList: action.data
      }
    case "SIGNATURE_POP":
      return {
        ...state,
        signaturePopStaus: action.data
      }
    case "SET_BORROW_LIST_POP":
      return {
        ...state,
        borrowListPop: action.data
      }
    case "GET_SERVICE_RECEIPT":
      return {
        ...state,
        serviceReceipt: action.data
      }
    case "GET_SERVICE_TOTALCOST":
      return {
        ...state,
        serviceTotalCost: action.data
      }
    case "FETCH_USEDPARTS_BORROWLIST":
      return {
        ...state,
        usedPartsBorrowList: action.data
      }
    case "SERVICE_MESSAGE_LIST":
      return {
        ...state,
        serviceMessageList: action.data
      }
    case "SERVICE_STAFF_PAYMENTS":
      return {
        ...state,
        serviceStaffPayments: action.data
      }
    case "SEARCH_SERVICE_FILTERS":
      return ({
        ...state,
        searchServiceFilters: action.data
      })
    case "GET_CUST_REQ_WITHOUT_LOGIN":
      return ({
        ...state,
        custReqWithoutLoginList: action.data
      })
    case "CUST_REQ_LOGIN_FILTERS":
      return ({
        ...state,
        custReqWithoutLoginFilters: action.data
      });
    case "SERVICE_REJECT_HISTORY":
      return ({
        ...state,
        serviceRejectHistory: action.data
      })
    case "GET_MSS_FILTERS":
      return ({
        ...state,
        manageSendingStaffFilters: action.data
      })
    case "GET_MSS_LIST":
      return ({
        ...state,
        manageSendingStaffList: action.data
      })
    case "SRV_ACC_LIST_FILTER":
      return ({
        ...state,
        srvAccListFilters: action.data
      })
    case "SRV_ACC_LIST":
      return ({
        ...state,
        srvAccList: action.data
      })
      case "SRV_COST_INCOME_FILTER":
        return ({
          ...state,
          srvCostIncomeFilters: action.data
        })
      case "SRV_COST_INCOME":
        return ({
          ...state,
          srvCostIncomeList: action.data
        })
      case "SRV_COST_INCOME_PRODUCT_FILTER":
        return ({
          ...state,
          srvCostIncomeByProductFilters: action.data
        })
      case "SRV_COST_INCOME_PRODUCT":
        return ({
          ...state,
          srvCostIncomeByProductList: action.data
        })        
        case "SRV_COST_INCOME_PTYPE":
          return ({
            ...state,
            srvCostIncomeByProductType: action.data
          })               
    case "SRV_ACC_LIST_PTYPE":
      return ({
        ...state,
        srvAccListByProductType: action.data
      })
    case "STAFF_SRV_TOTAL_COST":
      return ({
        ...state,
        srvTotalCostReport: action.data
      })
      case "STAFF_SRV_TOTAL_COST_MONTHLY":
        return ({
          ...state,
          srvTotalCostReportMonthly: action.data
        })
    case "STAFF_SRV_TOTAL_COST_FILTER":
      return ({
        ...state,
        srvTotalCostFilters: action.data
      });
    case "STAFF_SRV_COST_LIST_FILTER":
      return ({
        ...state,
        staffSRVCostListFilters: action.data
      })
    case "STAFF_SRV_COST_LIST":
      return ({
        ...state,
        staffSRVCostList: action.data
      })
    case "STAFF_MY_SRV_COST_LIST":
      return ({
        ...state,
        staffMySRVCostList: action.data
      })
    case "DEF_SRV_COST_DTL":
      return ({
        ...state,
        defServCostsDetailed: action.data
      });
    case "DEF_SRV_COST_DTL_FILTER":
      return ({
        ...state,
        defServCostsDtlFilters: action.data
      });
    case "DEF_SRV_COST_AGG_FILTER":
      return ({
        ...state,
        defServCostsAggFilters: action.data
      });
    case "DEF_SRV_COST_AGG":
      return ({
        ...state,
        defServCostsAgg: action.data
      })
    case "UP_COUNT_REP":
      return ({
        ...state,
        upCountReport: action.data
      });
    case "UP_COUNT_REP_FILTER":
      return ({
        ...state,
        upCountReportFilters: action.data
      });
    case "PRD_BUG_DTL_REP":
      return ({
        ...state,
        pBugDetailedReport: action.data
      });
    case "PRD_BUG_REP":
      return ({
        ...state,
        productBugReport: action.data
      });
    case "PRD_BUG_DTL_REP_FILTER":
      return ({
        ...state,
        pBugDetailedReportFilters: action.data
      })
    case "SA_ACCOUNTS_BOOK_FILTERS":
      return ({
        ...state,
        saAccBookFilters: action.data
      })
    case "SA_ACCOUNTS_BOOK_REPORT":
      return ({
        ...state,
        saAccBookReport: action.data
      })
      case "SWAPPED_SERIALS_REPORT_FILTERS":
        return({
          ...state,
          swappedSerialsReportFilters: action.data
        })
        case "SWAPPED_SERIALS_REPORT":
          return({
            ...state,
            swappedSerialsReportData:action.data
          })
          case "SRV_STAGE_STATUS_FILTER":
            return({
              ...state,
              serviceStageStatusReportFilter:action.data
            });
            case "SRV_STAGE_STATUS_REPORT":
              return({
                ...state,
                serviceStageStatusReport:action.data
              })
              case "VIP_SERVICE_LIST":
                return({
                  ...state,
                  vipServiceList:action.data
                });
                case "SERVICE_TURNAROUND":
                  return({
                    ...state,
                    serviceTurnaroundTimeReport:action.data
                  })
    default:
      return state;
  }
}

export default service;